import { useQuery } from "convex/react";
import { anyApi } from "convex/server";

// Whether the signed-in user has publicMetadata.isAdmin === true in
// Clerk. Used to gate the "Add a property" affordances; matches the
// requireAdmin gate on properties.create. Returns false while the
// query is in flight (default to least-privileged).
export function useIsAdmin(): boolean {
  const result = useQuery(anyApi.users.isMeAdmin, {}) as boolean | undefined;
  return result === true;
}
